import {
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField,
  } from "@mui/material";
  import { useRef, useState } from "react";
  import { BaseProps } from "src/components/move-inRegistrationTabs/interfaces";
  import NocsRequests from "../../stores/NocsRequestsStore";
  import General from "../../stores/GeneralStore";
import CloseIcon from "../../assets/CloseIcon.svg";
import { validateDate } from "@mui/x-date-pickers/internals";

  interface Obj {
    [key: string]: string;
  }
  
  interface Props {
    onValidateClick: any;

  }
  
  const NoMobileModalExist = ({ onValidateClick }: Props) => {
    const ColorAss = General?.ColorAss;
    const contrast=General?.contrast;
    return (
      <div
        style={{
          width:General?.isLargeScreen? "60%":"100%",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#fff",
          margin: "auto",
          direction:General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode =="ARA"? "rtl": "ltr",
        }}
      >
         <div
          style={{
            // height: '20%',
            width: "100%",
            justifyContent: "space-between",
            paddingLeft: "1rem",
            paddingRight: "1rem",
            background: "#101e8e",
            display: "flex",
            alignItems: "center",
          }}
        >
          <h1 style={{ color: contrast?.contrastColor ? contrast?.contrastColor :"#fff", justifySelf: "flex-start" }}>
          Mobile Number Not Available
          </h1>
          <img src={CloseIcon} alt="" onClick={onValidateClick} />
        </div>
       <div style={{padding:'1rem'}}>
       <span style={{ fontSize: `${General.accessibility.fontSize}rem` }}>
       Mobile number or Email  not available to send otp
             
            </span>
            <br />
          
  
        
  
        <button
          onClick={onValidateClick}
          style={{
            background: "#101e8e",
            color: "#fff",
            height: "3.5rem",
            width: "12.5rem",
            fontSize: `${1.5 * General.accessibility.fontSize}rem`,
            marginTop:'2rem'
          }}
        >
          {General?.codeLabels['cm_close'].label}
        </button>
       </div>
      </div>
    );
  };
  
  export default NoMobileModalExist;
  